import Avatar from '@component/avatar'
import ReviewStar from '@component/reviewStar/star'
import { getTime } from '@utils'
import ReviewShareButton from './share'

export default function AgentReviewCard({
  data,
  agent
}) {
  return (
    <div className='border p-26 rounded-xs'>
      <div className='flex flex-col items-start justify-between sm:flex-row sm:items-center'>
        <span className='text-base text-font'>{data.name}</span>
        <div className='flex items-center w-full justify-between sm:w-auto'>
          <div className='flex items-center mr-16'>
            <i className='icon icon-ok'></i>
            <span className='text-sm ml-10'>Verified review</span>
          </div>
          <ReviewShareButton></ReviewShareButton>
        </div>
      </div>
      <div className='text-font text-base mt-10 sm:mt-0'>{data.address}</div>
      <div className='flex items-center mt-6'>
        <ReviewStar count={5} value={data.score} fill='var(--color-ref-secondary)'></ReviewStar>
        <span className='text-sm ml-20 text-neutral-5'>{getTime(data.createTime, 'MMM, YYYY')}</span>
      </div>
      <div className='mt-10 text-base text-neutral-5' dangerouslySetInnerHTML={{ __html: data.review || '' }}></div>
      {
        data.reply && (
          <div className='flex mt-36 border-l-4 border-l-primary pl-12'>
            <Avatar src={agent.icon} alt={agent.name} width={42} height={42} circle className='flex-shrink-0' defaultIcon='icon-avatar'></Avatar>
            <div className='ml-8 text-font'>
              <div className='text-base'>{agent.name} replied:</div>
              <div className='text-sm break-words'>{data.reply}</div>
            </div>
          </div>
        )
      }
    </div>
  )
}

export function SkeletonCard () {
  return (
    <div className='skeleton-wrap space-y-10'>
      <div className='flex justify-between'>
        <span className='h-14 w-1/3'></span>
        <span className='h-14 w-1/6'></span>
      </div>
      <span className='h-10 w-2/3'></span>
      <span className='h-10 !mt-16'></span>
      <span className='h-10'></span>
      <span className='h-10'></span>
      <span className='h-10 w-5/6'></span>
    </div>
  )
}